import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import * as React from 'react';
import { Button } from './dump/Button';
import { Phone } from './dump/Phone';
import { handleDynamicCalltracking } from '../../utils/handleDynamicCalltracking';
import { jsx as _jsx } from "react/jsx-runtime";
export var PhoneButton = function PhoneButton(_ref) {
  var PhoneComponent = _ref.PhoneComponent,
    buttonText = _ref.buttonText,
    httpApi = _ref.httpApi,
    isOpenProp = _ref.isOpen,
    logger = _ref.logger,
    onClickProp = _ref.onClick,
    pageType = _ref.pageType,
    phone = _ref.phone,
    placeType = _ref.placeType,
    platformType = _ref.platformType,
    realtyUserId = _ref.realtyUserId,
    siteBlockId = _ref.siteBlockId,
    styles = _ref.styles,
    phoneButtonTestId = _ref.phoneButtonTestId;
  var _React$useState = React.useState(!!isOpenProp),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isOpen = _React$useState2[0],
    setIsOpen = _React$useState2[1];
  var _React$useState3 = React.useState(phone),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    dynamicPhone = _React$useState4[0],
    setPhone = _React$useState4[1];
  var onClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$handleDynamicC, _phone;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!siteBlockId) {
              _context.next = 6;
              break;
            }
            _context.next = 3;
            return handleDynamicCalltracking({
              blockId: siteBlockId,
              platformType: platformType,
              pageType: pageType,
              placeType: placeType,
              httpApi: httpApi,
              logger: logger
            });
          case 3:
            _yield$handleDynamicC = _context.sent;
            _phone = _yield$handleDynamicC.phone;
            if (_phone) {
              setPhone(_phone);
            }
          case 6:
            setIsOpen(true);

            /* istanbul ignore else */
            if (onClickProp) {
              onClickProp({
                realtyUserId: realtyUserId,
                phone: dynamicPhone
              });
            }
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onClick() {
      return _ref2.apply(this, arguments);
    };
  }();
  if (isOpen) {
    return PhoneComponent ? /*#__PURE__*/_jsx(PhoneComponent, {
      phone: dynamicPhone,
      siteBlockId: siteBlockId,
      realtyUserId: realtyUserId
    }) : /*#__PURE__*/_jsx(Phone, {
      phone: dynamicPhone
    });
  }
  return /*#__PURE__*/_jsx(Button, {
    phoneButtonTestId: phoneButtonTestId || 'PhoneButton',
    styles: styles,
    onClick: onClick,
    buttonText: buttonText
  });
};